(function () {
    const input = {
        $name: $('input[name="name"]'),
        $phone: $('input[name="phone"]'),
        $birthday: $('input[name="birthday"]'),
        $date: $('input[name="date"]'),
        $time: $('input[name="time"]'),
        $sum: $('input[name="sum"]'),
        $contract: $('input[name="contract_num"]'),
    }

    input.$name.mask('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA', {
        translation: {
            A: {pattern: /[А-я\s]/}
        },
        placeholder: 'Ваше имя'
    })

    input.$phone.mask('+7 (ZZZ) ZZZ-ZZ-ZZ', {
        translation: {
          Z: {pattern: /[0-9]/}
        },
        placeholder: 'Мобильный телефон'
    })

    input.$birthday
        .on({
            focus: function () {
                $(this).attr('placeholder', 'ДД.ММ.ГГГГ')
            }
        })
        .mask('DZ.DZ.DDDD', {
            translation: {
                D: {pattern: /[0-9]/},
                Z: {pattern: /[0-9]/, optional: true}
            },
            placeholder: 'Дата рождения'
        })

    input.$date.mask('DZ.DZ.DDDD', {
        translation: {
          D: {pattern: /[0-9]/},
          Z: {pattern: /[0-9]/, optional: true}
        },
        placeholder: 'Дата'
    })

    input.$time.mask('DZ:DZ', {
        translation: {
          D: {pattern: /[0-9]/},
          Z: {pattern: /[0-9]/, optional: true}
        },
        placeholder: 'Время'
    })

    input.$sum.mask('DDDBBBBBBBBBBBB', {
        translation: {
          D: {pattern: /[0-9]/},
          B: {pattern: /[0-9]/, optional: true}
        },
        placeholder: 'Сумма'
    })

    input.$contract
        .on({
            focus: function () {
                $(this).attr('placeholder', '00АА000000000000')
            }
        })
        .mask('AABBAAAAAAAAAAAA', {
            translation: {
                A: {pattern: /[0-9]/},
                B: {pattern: /[А-я]/}
            },
            placeholder: 'Номер договора'
        })
})()